import * as React from "react";
import { generateBlock } from "./block_renderer";
export class AsyncBlock extends React.Component {
    componentDidMount() {
        this.props.promise().then((data)=>this.setState({
                data
            }));
    }
    render() {
        return this.state.data != "loading" && this.state.data != 'error' ? generateBlock(this.props.block(this.state.data)) : null;
    }
    constructor(props){
        super(props);
        this.state = {
            data: "loading"
        };
    }
}
